module.exports = __webpack_public_path__ + "media/customizations/tavolalife/logo-d14f2396a6dea9b1e4e3bc22e664228f.png";